import { AreaDesignerManager } from '../areaDesignerManager';
import AreaDesignerPlugin from './areaDesignerPlugin';

export class AreaDesignerGridCheckerPlugin implements AreaDesignerPlugin {
    private manager!: AreaDesignerManager;
    private checkerSize = 20;

    private layer!: paper.Layer;

    private gridCache: [number, number, paper.SymbolItem | null, boolean][] = [];

    private symbol!: paper.SymbolDefinition;

    private updateCheckerGrid = () => {
        if (this.manager.mode === 'VIEWER') return;

        const viewBounds = this.manager.paper.view.bounds;

        const startX = Math.floor(viewBounds.left / this.checkerSize);
        const startY = Math.floor(viewBounds.top / this.checkerSize);
        const endX = Math.ceil(viewBounds.right / this.checkerSize);
        const endY = Math.ceil(viewBounds.bottom / this.checkerSize);

        const scale = this.checkerSize / this.symbol.item.bounds.width;
        this.symbol.item.scaling = new this.manager.paper.Point(scale, scale);

        for (let y = startY; y < endY; y++) {
            for (let x = startX; x < endX; x++) {
                // Get grid position from cache
                const gridCachePosition = this.gridCache.find((a) => a[0] == x && a[1] == y);
                if (Math.abs(x % 2) == Math.abs(y % 2) && (!gridCachePosition || !gridCachePosition[3])) {
                    var rectangle = this.symbol.place(new this.manager.paper.Point(x * this.checkerSize, y * this.checkerSize));

                    this.layer.addChild(rectangle);

                    // Fill the grid
                    if (!gridCachePosition) {
                        this.gridCache.push([x, y, rectangle, true]);
                    } else {
                        gridCachePosition[2] = rectangle;
                        gridCachePosition[3] = true;
                    }
                }
            }
        }

        // Clean
        for (const gridPosition of this.gridCache) {
            const [x, y, rectangle] = gridPosition;
            if (x < startX || x > endX || y < startY || y > endY) {
                rectangle?.remove();
                gridPosition[2] = null;
                gridPosition[3] = false;
            }
        }
    };

    private clearGrid = () => {
        if (this.manager.mode === 'VIEWER') return;

        this.layer.removeChildren();
        this.gridCache = [];
    };

    public create = (manager: AreaDesignerManager) => {
        this.manager = manager;

        if (manager.mode === 'VIEWER') return;

        this.layer = new manager.paper.Layer();
        this.layer.sendToBack();

        const square = new this.manager.paper.Path.Rectangle(
            new this.manager.paper.Rectangle({
                width: this.checkerSize,
                height: this.checkerSize
            })
        );

        square.fillColor = new this.manager.paper.Color('#E8E8E8');
        square.sendToBack();

        this.symbol = new this.manager.paper.SymbolDefinition(square);

        this.updateCheckerGrid();
    };

    public onViewMoved = () => {
        if (this.manager.mode === 'VIEWER') return;

        this.updateCheckerGrid();
    };

    public onViewZoomChanged = () => {
        if (this.manager.mode === 'VIEWER') return;

        this.checkerSize = 20 / this.manager.paper.view.zoom;
        this.clearGrid();
        this.updateCheckerGrid();
    };
}
